import { createServerFn } from "@tanstack/react-start";
import { preparedAccount, readAccount, readSignIn, type SignInQuery } from "./auth.server";
import { privateResponse, publicationResponse, siteContext } from "./site.server";

const text = (value: unknown, limit = 2000) =>
  typeof value === "string" && value.length <= limit ? value : null;

/** A sign-in or sign-up page, for a document request or a client navigation. */
export const loadSignIn = createServerFn({ method: "GET" })
  .validator((input: unknown): SignInQuery => {
    const query = (input ?? {}) as Record<string, unknown>;
    return {
      signUp: query.signUp === true,
      returnTo: text(query.returnTo),
      method: text(query.method, 40),
      sent: text(query.sent, 40),
      error: text(query.error, 40),
      reset: query.reset === true,
    };
  })
  .handler(async ({ data, context }) => {
    const drate = await siteContext(context);
    const page = await readSignIn(drate, data, new URL(drate.request.url).origin);
    publicationResponse(drate);
    return page;
  });

/** The signed-in member's account page. */
export const loadAccount = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (drate.creator && publicationResponse(drate)) return preparedAccount(drate.creator.name);
  return readAccount(drate);
});

/** Recovery pages contain public controls; reset tokens stay in the request, never preparation. */
export const loadRecovery = createServerFn({ method: "GET" })
  .validator((path: unknown) => {
    if (path !== "/forgot-password" && path !== "/reset-password")
      throw new Error("Invalid recovery page");
    return path;
  })
  .handler(async ({ context }) => {
    const drate = await siteContext(context);
    if (!publicationResponse(drate)) privateResponse();
    return null;
  });
